import React, {useState, useEffect} from 'react';
import './App.css';
import {Button, FormControl, Input, IconButton, Card, Typography, CardContent} from '@material-ui/core';
import Message from './Message';
import db from './firebase';
import firebase from "firebase";
import FlipMove from "react-flip-move";
import SettingsBrightnessIcon from "@material-ui/icons/SettingsBrightness";



function App() {
  const [input, setInput] = useState("");//State hooks used to store/change values.
  const [messages, setMessages] = useState([]);
  const [username, setUsername] = useState("");
  const [counter, setCounter] = useState(0);
  
  let Theme = true;//true=lightmode, false=darkmode.

  useEffect(() => {//Retrieves the messages database from firebase and stores the messages list in their respective state hook. 
                   //listener (onSnapshot) updates the displayed message when the database is changed.
    document.title = "Current News Chat"
    db.collection('messages').orderBy("timestamp", "desc").onSnapshot(snapshot => {setMessages(snapshot.docs.map(doc => ({id: doc.id, message: doc.data()})))});
    
  }, [] )

  useEffect(() => {
    
    setUsername(prompt("Please enter your name"));
    updateHeadline();
    var docRef = db.collection("news").doc("currentnews");

    docRef.get().then(function(doc) {
      if (doc.exists) {//Sets the current topic/desc field on startup of website.
        document.getElementById("description").innerHTML = doc.data().currentdescription;
        document.getElementById("topic").innerHTML = doc.data().currenttitle;

      }
      else {// doc.data() will be undefined in this case
        console.log("No such document!");
      }
    }).catch(function(error) {
      console.log("Error getting document:", error);
    });

    db.collection("news").doc("currentnews").onSnapshot(function(doc) {//Sets the topic/desc for connected users when the topic/desc is changed by someone.
      document.getElementById("description").innerHTML = doc.data().currentdescription;
      document.getElementById("topic").innerHTML = doc.data().currenttitle;

    });



  }, [] ) // condition to run code, if [] is blank, code runs once when app loads.


  const setnewHeadline = (event) => {//When the next headline button is clicked: change the news to be the next one from the 30 retrieved from 1 API call.
    if (counter > 29) {
      setCounter(0);
    }
    let newsRef = db.collection("news");
    newsRef.doc("currentnews").set({currenttitle: topictitle[counter], currentdescription: topicdescription[counter]});
    setCounter(counter + 1);

  }


  const updateHeadline = (event) => { //This returns a JSON object with the results in an array we can iterate over. 
    let url = 'https://api.currentsapi.services/v1/latest-news?language=en&apiKey=jkUn4oq-igqv7TGYRLOGquC93Df3J8vVybtcx2yfAA8k03NI';
    let req = new Request(url);
    fetch(req)
    .then(function(response) 
      {response.json().then(function(data) {
        
        let result = data.news;
        for (let i of Array(30).keys()){
          topictitle.push(result[i].title);
          topicdescription.push(result[i].description);

        }
      })}
    
    );
  }
    

  const sendMessage = (event) => {//Sends message to the database.
    event.preventDefault();

    db.collection("messages").add({
      text: input, username: username, timestamp: firebase.firestore.FieldValue.serverTimestamp()
    })

    setInput("");

  }

  const setTheme = (event) => {
    if (Theme){
      setDarkTheme();
    }
    else {
      setLightTheme();
    }
  }

  function setDarkTheme(){
    document.body.style.backgroundColor = "#242423";
    document.getElementById("App").style.backgroundColor = "#242423";
    document.getElementsByTagName("h1")[0].style.color = "white";
    document.getElementsByTagName("h2")[0].style.color = "white";
    document.getElementById("news").style.backgroundColor = "#333333";
    document.getElementById("news").style.color = "white";
    document.getElementById("nextheadline").style.backgroundColor = "#474747";
    document.getElementById("nextheadline").style.color = "white";

    Theme = false;
  }

  function setLightTheme(){
    document.body.style.backgroundColor = "white";
    document.getElementById("App").style.backgroundColor = "white";
    document.getElementsByTagName("h1")[0].style.color = "black";
    document.getElementsByTagName("h2")[0].style.color = "black";
    document.getElementById("news").style.backgroundColor = "white";
    document.getElementById("news").style.color = "black";
    document.getElementById("nextheadline").style.backgroundColor = "white";
    document.getElementById("nextheadline").style.color = "black";

    Theme = true;
  }


  return (
    <div className="App" id="App">
      <IconButton className="App__theme" onClick={setTheme}><SettingsBrightnessIcon/></IconButton>

      <h1>Current News Chat</h1>
      <h2>Welcome to the chat, {`${username || "Unknown User"}`}!</h2>
      
      <Card variant="outlined" id="news">
      <CardContent>
        <Typography id="topic" variant="h5" component="h2">
          
        </Typography>
        <Typography variant="body2" component="p" id="description">
          
        </Typography>
        <Button id="nextheadline" onClick={setnewHeadline}>Next Headline</Button>
        
      </CardContent>
      </Card>

      <form className="app__form">
      <FormControl className="app__formControl">
        <Input className="app__input" placeholder="Enter a message..." value={input} onChange={event => setInput(event.target.value)}/>
        <Button className="app__iconButton" disabled={!input} variant="contained" color="primary" type="submit" onClick={sendMessage}>Send</Button>

      </FormControl>
      </form>

      <FlipMove>
        {
          messages.map(({id ,message}) => (
            <Message key = {id} username = {username} message={message}/>
            
          ))
        }
      </FlipMove>

    </div>
  );
}

let topictitle = [];
let topicdescription = [];

export default App;
